import localforage from 'localforage';

localforage.config({
  name: 'asl-pwa', // Specify a unique name for your app
  storeName: 'asl-store', // Specify a name for the data store
});

export default localforage;